module.exports = __webpack_public_path__ + "static/img/15.ee4c7c52.png";